import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Profile, User } from '../../types/models';

interface UserState {
  currentUser: User | null;
  users: User[];
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  currentUser: null,
  users: [],
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    fetchUserStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchUserSuccess: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchUsersSuccess: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchUserFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateUserSuccess: (state, action: PayloadAction<User>) => {
      if (state.currentUser && state.currentUser.userId === action.payload.userId) {
        state.currentUser = action.payload;
      }
      state.users = state.users.map(user => 
        user.userId === action.payload.userId ? action.payload : user
      );
      state.loading = false;
      state.error = null;
    },
    setCurrentUserProfile: (state, action: PayloadAction<Profile | null>) => {
      if (state.currentUser) {
        state.currentUser = { ...state.currentUser, profile: action.payload };
      }
    },
    clearUserError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchUserStart,
  fetchUserSuccess,
  fetchUsersSuccess,
  fetchUserFailure,
  updateUserSuccess,
  setCurrentUserProfile,
  clearUserError,
} = userSlice.actions;

export default userSlice.reducer;
